export default __webpack_public_path__ + "static/ExploreOurProductsBg-9435ef86d3fd4c737d492396daac2d4b.webp";